export const listProviderMappingsQuery = `
    query listProviderMappings($filter: ProviderMappingsFilterInput) {
        listProviderMappings(filter: $filter) {
            items {
                id
                entityType
                localEntityId
                billingProviderId
                billingProvider {
                    id
                    key
                    name
                }
                providerEntityId
                syncStatus
                created
                updated
            }
            nextToken
        }
    }
`;

export const getProviderMappingQuery = `
    query getProviderMapping($id: ID!) {
        getProviderMapping(id: $id) {
            id
            entityType
            localEntityId
            billingProviderId
            providerEntityId
            syncStatus
            created
            updated
        }
    }
`;
